import {Backend} from '@common/backend'
import {Util} from 'yougile-util'
import {FileLoader} from './types'
import {uploadFile} from './upload-by-file'

export function CustomUploadAdapterPlugin(editor: any): void {
  const fileRepositoryPlugin = editor.plugins.get('FileRepository')

  const createUploadAdapter = (loader: FileLoader): CustomUploadAdapter =>
    new CustomUploadAdapter(loader)

  fileRepositoryPlugin.createUploadAdapter = createUploadAdapter
}

class CustomUploadAdapter {
  constructor(loader: FileLoader) {
    this.loader = loader
  }

  loader: FileLoader

  async upload(): Promise<{default: string}> {
    const file = await this.loader.file
    const url = await uploadFile(file)

    const urlWithHost = Util.isDesktop()
      ? Backend.toDataUrl(url)
      : `${window.location.origin}${url}`

    return {
      default: urlWithHost
    }
  }
}
